const accordions = document.querySelectorAll('.accordion__title')

if (accordions.length) {
  const accordionActiveClass = 'accordion--active'

  accordions.forEach((item) => {
    item.addEventListener('click', function () {
      const parent = item.closest('.accordion')
      const textEl = parent.querySelector('.accordion__content')

      if (parent.classList.contains(accordionActiveClass)) {
        parent.classList.remove(accordionActiveClass)
        textEl.style.height = 0
      } else {
        parent.classList.add(accordionActiveClass)
        textEl.style.height = 'auto'
        const targetHeight = textEl.scrollHeight + 'px'
        textEl.style.height = 0

        setTimeout(() => {
          textEl.style.height = targetHeight
        }, 0)
      }
    })
  })
}
